export default __webpack_public_path__ + "static/media/641.5288ae0a.jpg";